import { apiUrl2 } from '../../../settings'

export const getGicCommissionReportsUrl = () => {
  return `${apiUrl2}/getGicCommissionReports`
}

export const getGicTotalPendingBlcUrl = () => {
  return `${apiUrl2}/getGicPendBalcTotal`
}
